import React from "react";
import { images, whyReasons } from "../data/content";
export function WhyBuildersLove() {
  return <section className="bg-white px-4 py-14" aria-labelledby="why-title" data-id="element-182" data-mp="103xs6daxiq0o">
      <div className="mx-auto max-w-5xl" data-id="element-183" data-mp="1dusu15n0g6ur">
        <h2 className="text-center font-heading text-2xl font-bold uppercase md:text-3xl" data-id="element-184" data-mp="1dvugs7de2hsb">Discover why builders love this pack</h2>
        <p className="mt-2 text-center text-sm text-ink-muted" data-id="element-185" data-mp="192sxln65fw2x">Plans made by woodworkers, for people who want results.</p>
        <div className="mt-10 grid items-center gap-10 md:grid-cols-2" data-id="element-186" data-mp="1itw1sxudkr6f">
          <img src={images.blueprint} alt="Technical plans for a coffee table" className="w-full rounded-lg" data-id="element-187" data-mp="1itnox5y95lv8" />
          <div data-id="element-188" data-mp="1wrkjxxx25k7s">
            <h3 id="why-title" className="font-heading text-2xl font-bold uppercase leading-tight" data-id="element-189" data-mp="1ss3ev5ljmp35">
              Why DIY enthusiasts <span className="text-brand" data-id="element-190" data-mp="2f47ughkzbv0">love this pack</span>
            </h3>
            <dl className="mt-6 space-y-5" data-id="element-191" data-mp="3ujga12xplim0">
              {whyReasons.map(r => <div key={r.title} className="border-l-2 border-brand pl-4" data-id="element-192" data-mp="3ul9dk9d0zmps">
                  <dt className="font-heading font-semibold" data-id="element-193" data-mp="zbzwacncv8op">{r.title}</dt>
                  <dd className="mt-1 text-sm leading-relaxed text-ink-muted" data-id="element-194" data-mp="14904at3rmlig">{r.text}</dd>
                </div>)}
            </dl>
          </div>
        </div>
      </div>
    </section>;
}